var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0271 12.8476L17.5963 16.4159L16.4171 17.5951L12.8488 14.0259C11.5211 15.0903 9.86964 15.6692 8.16797 15.6667C4.02797 15.6667 0.667969 12.3067 0.667969 8.16675C0.667969 4.02675 4.02797 0.666748 8.16797 0.666748C12.308 0.666748 15.668 4.02675 15.668 8.16675C15.6704 9.86842 15.0915 11.5199 14.0271 12.8476ZM12.3555 12.2292C13.4131 11.1417 14.0037 9.68377 14.0013 8.16675C14.0013 4.94341 11.3905 2.33341 8.16797 2.33341C4.94464 2.33341 2.33464 4.94341 2.33464 8.16675C2.33464 11.3892 4.94464 14.0001 8.16797 14.0001C9.68499 14.0025 11.1429 13.4118 12.2305 12.3542L12.3555 12.2292Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.6a116a71b4be9e2dd143a99f69d17086.svg";
export { ForwardRef as ReactComponent };